// extracted by mini-css-extract-plugin
export default {"entrypoints":"style_entrypoints__Ms22T","title":"style_title__RMtJ9"};